import { AbstractMesh, TransformNode } from '@babylonjs/core';

import BodyPart from './BodyPart';

export type BodyPartHierarchy = {
  skeletalSystem: {
    lowerLimbs: {
      fibula: BodyPart;
      tibia: BodyPart;
      hips: BodyPart;
      femurs: BodyPart;
    };
    ribCage: BodyPart;
    skull: BodyPart;
    spine: BodyPart;
    clavicle: BodyPart;
    shoulders: BodyPart;
    upperLimbs: {
      humerus: BodyPart;
      radius: BodyPart;
      ulna: BodyPart;
      carpals: BodyPart;
      metacarpus: BodyPart;
    };
  };
};

export default class Body {
  // The flat array of TransformNodes that contain all the meshes.
  public meshGroups: TransformNode[];

  public bodyParts: BodyPartHierarchy;

  public meshToBodyPart = new Map<number, BodyPart>();

  constructor(meshGroups: TransformNode[]) {
    this.meshGroups = meshGroups;

    this.bodyParts = {
      skeletalSystem: {
        lowerLimbs: {
          fibula: new BodyPart('fibula', 'vadben', this.getBodyPartMeshesByName('Fibula'), this.meshToBodyPart),
          tibia: new BodyPart('tibia', 'skenben', this.getBodyPartMeshesByName('Tibia'), this.meshToBodyPart),
          hips: new BodyPart('hips', 'bäcken', this.getBodyPartMeshesByName('Hips'), this.meshToBodyPart),
          femurs: new BodyPart('femurs', 'lårben', this.getBodyPartMeshesByName('Femurs'), this.meshToBodyPart),
        },
        ribCage: new BodyPart('ribcage', 'bröstkorg', this.getBodyPartMeshesByName('Ribcage'), this.meshToBodyPart),
        clavicle: new BodyPart('clavicle', 'nyckelben', this.getBodyPartMeshesByName('Clavicle'), this.meshToBodyPart),
        skull: new BodyPart('skull', 'kranium', this.getBodyPartMeshesByName('Skull'), this.meshToBodyPart),
        spine: new BodyPart('spine', 'ryggrad', this.getBodyPartMeshesByName('Spine'), this.meshToBodyPart),
        shoulders: new BodyPart(
          'shoulders',
          'skulderblad',
          this.getBodyPartMeshesByName('Shoulders'),
          this.meshToBodyPart,
        ),
        upperLimbs: {
          humerus: new BodyPart('humerus', 'överarmsben', this.getBodyPartMeshesByName('Humerus'), this.meshToBodyPart),
          ulna: new BodyPart('ulna', 'armbågsben', this.getBodyPartMeshesByName('Ulna'), this.meshToBodyPart),
          radius: new BodyPart('radius', 'strålben', this.getBodyPartMeshesByName('Radius'), this.meshToBodyPart),
          carpals: new BodyPart(
            'carpals',
            'handlovsben',
            this.getBodyPartMeshesByName('Carpal_Bones'),
            this.meshToBodyPart,
          ),
          metacarpus: new BodyPart(
            'metacarpus',
            'mellanhand',
            this.getBodyPartMeshesByName('Metacarpus'),
            this.meshToBodyPart,
          ),
        },
      },
    };
  }

  private getBodyPartMeshesByName(name: string): AbstractMesh[] {
    const meshGroup = this.meshGroups.find((node) => node.name === name);
    return meshGroup!.getChildMeshes(true);
  }
}
